import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const pointsApiRoutes = {
    get: apiSchematicMapBaseURL + "data/",
};

export class PointAPI {
    static getStops(networkEdition, pathIds) {
        const url = `${pointsApiRoutes.get}stops/${networkEdition}/${pathIds}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getMapPoints(networkEdition, pathIds) {
        const url = `${pointsApiRoutes.get}mappoints/${networkEdition}/${pathIds}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getAllMapPoints(networkEdition) {
        const url = `${pointsApiRoutes.get}mappoints/${networkEdition}/`;
        
        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
